import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/memberRevenue/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/memberRevenue/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/memberRevenue/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/memberRevenue/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/memberRevenue/delete/batch', {
    params: {
      ids
    }
  })
}
// 导出Excel
export function exportExcel (data) {
  return request.post('/business/memberRevenue/exportExcel', data, {
    download: true
  })
}
